import aiChat from './aiChat.reducer';

const reducer = {
  aiChat,
};

export default reducer;
